import axios, { AxiosRequestConfig } from 'axios'
import { IPublicClientApplication } from '@azure/msal-browser'
import { reactMainApiBaseUrl, reactMainApiIncidentRetrievalPoolSize, customerKey, msalMainApiRequest } from "../../../configuration"
import GetAccessToken from '../../functions/security/AccessTokenProvider'
import IUserIncidentDecisionMakerClue from '../../interfaces/entityIncident/IUserIncidentDecisionMakerClue'
import IUser from '../../interfaces/user/IUser'

export default async function GetUsers(publicClientApplication:IPublicClientApplication, customerID:string, domain:string, searchPattern:string):Promise<IUser[]> {

  const accessToken = await GetAccessToken(publicClientApplication, msalMainApiRequest)
  const parameters = await createRequestParameters(customerID, domain, searchPattern)
  const requestConfiguration:AxiosRequestConfig = {
    url: (reactMainApiBaseUrl(customerID) + '/users'),
    method: 'GET',
    params: parameters,
    headers: { Authorization: ('Bearer ' + accessToken)},
  }

  return axios(requestConfiguration)
    .then(result => result.data)
    .catch(event => Error("Could not retrieve users from Sense React Api.\n\n" + event))
}

const createRequestParameters = async (customerID:string, domain:string, searchPattern:string) => {

  const parameters = new URLSearchParams()

  parameters.append('code', customerKey)
  parameters.append('id', customerID)
  parameters.append('domain', domain)
  parameters.append('search-pattern', searchPattern)

  return parameters
}